import { Container } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { MyParams, auditor } from 'App';
import { useParams } from 'react-router-dom';
import { PageTitle, ReportCard, ReportsErrorBox } from './components';
import { Loader } from '@shared';

export function TargetReport() {
  const { session: sessionUuid } = useParams<keyof MyParams>() as MyParams;

  const { data, isError, isLoading } = useQuery(['exam session', sessionUuid], () =>
    auditor.getTargetReport(sessionUuid)
  );
  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return null;
  }
  return (
    <Container component='article' sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <PageTitle
        streamUiBaseUrl={data.streamUiBaseUrl}
        streamHandle={data.streamHandle}
        examSessionUuid={data.examSessionUuid}
        partnerName={data.partner.name}
        partnerTargetProfile={data.partnerTargetProfile}
      />
      {data.error && <ReportsErrorBox error={data.error} />}
      {data.reports?.map((report) => (
        <ReportCard
          report={report}
          key={report.name}
          partnerTargetProfile={data.partnerTargetProfile}
        />
      ))}
    </Container>
  );
}
